export default __webpack_public_path__ + "static/media/gallery-12-2.5224465b.webp";